export default "__VITE_ASSET__UKFxbvIt__"